<template>
    <card class="card-pricing bg-gradient-default border-0 text-center mb-4"
        header-classes="bg-transparent"
        body-classes="px-lg-7"
        footer-classes="bg-transparent"
        v-if="registration">

        <registration-info :registration="registration" v-if="showDetails"></registration-info>

        <div class="display-3 text-white mb-3">
            {{ registration.degree.name }}
        </div>

        <base-progress class="mb-0" type="info" :value="progress(registration)">
        </base-progress>

        <div class="text-center text-white mb-4" style="margin-top:-10px;">
            {{ progress(registration) }}% {{ $t('dashboard.done').toLowerCase() }}
            <span v-if="registration.state.remedial_sessions">
                + {{ registration.state.remedial_sessions }} {{ $t('dashboard.remedial-s').toLowerCase() }}
            </span>
        </div>

        <div class="row mb-3" v-if="registration.state.from">
            <div class="col-12 text-center pb-2">
                <span class="icon icon-xs icon-shape bg-white shadow rounded-circle">
                    <i class="fas fa-calendar-alt"></i>
                </span>
                <span class="pl-2 text-sm text-white">
                    <span class="text-muted">{{ $t('common.from') }}</span> {{ date(registration.state.from) }}
                    <span class="text-muted">{{ $t('common.to').toLowerCase() }}</span> {{ date(registration.state.to) }}
                </span>
            </div>
        </div>

        <div class="mb-2 mt-4">

            <base-button type="secondary" @click="openResources" v-if="showDetails && $permissions.hasRight('dashboard.resources.read')">
                {{ $t('common.resources') }}
            </base-button>

            <base-button type="secondary" @click="openElearning" v-if="showDetails">
                {{ $t('common.elearning') }}
            </base-button>

            <base-button type="secondary" @click="openOverview" v-if="navToOverview">
                {{ $t('dashboard.overview') }}
            </base-button>

            <base-button type="secondary" @click="openMore" v-if="canNavToDetails">
                {{ $t('overview.sessions-details') }}
            </base-button>
        </div>

        <portal to="modals">

            <comment-modal v-model="modals.comment" :comment="comment">
            </comment-modal>

            <base-modal
                v-model="modals.resources"
                :title="$t('common.resources')"
                body-classes="py-0"
            >
                <resources :registration="registration">
                </resources>
            </base-modal>

            <base-modal
                v-model="modals.elearning"
                :title="$t('common.elearning')"
                body-classes="py-0"
            >
                <elearning :registration="registration" :learner="learner">
                </elearning>
            </base-modal>
        </portal>
    </card>
</template>

<script>
    import ModalsController from '@trax/classes/ModalsController'
    import RegistrationInfo from '../common/RegistrationInfo'
    import Resources from '../common/Resources'
    import Elearning from './Elearning'
    import CommentModal from './CommentModal'
    import moment from 'moment'

    export default {

        components: {
            Resources, Elearning, CommentModal, RegistrationInfo
        },

        props: {

            registration: {
                type: Object,
            },

            learner: {
                type: Object,
            },

            groups: {
                type: Array,
            },

            showDetails: {
                type: Boolean,
                default: true
            },

            navToOverview: {
                type: Boolean,
                default: false
            },

            navToDetails: {
                type: Boolean,
                default: false
            }
        },

        data() {
            return {
                modals: new ModalsController(['comment', 'resources', 'elearning']),
                moment: moment,
            }
        },

        computed: {

            comment() {
                return {
                    title: this.registration ? this.registration.degree.name : null,
                    content: this.registration ? this.registration.state.comment : null,
                    author: this.registration ? this.registration.state.instructor_name : null,
                }
            },

            canNavToDetails() {
                if (!this.navToDetails) {
                    return false
                }
                return this.$permissions.hasRight('dashboard.simulations.read')
            }
        },

        methods: {

            progress(registration) {
                if (registration.state.sessions_count == 0) {
                    return 0
                }
                let progress = (registration.state.completed_sessions ? registration.state.completed_sessions : 0) * 100 / registration.state.sessions_count
                return parseInt(progress)
            },

            date(date) {
                return this.moment(date).format('YYYY/MM/DD')
            },

            openResources() {
                this.modals.open('resources')
            },

            openElearning() {
                this.modals.open('elearning')
            },

            openOverview() {
                this.$router.push({
                    name: 'dashboard-learner-registration-overview',
                    params: {
                        learnerId: this.learner.id,
                        registrationId: this.registration.id
                    }
                })
            },

            openMore() {
                this.$router.push({
                    name: 'dashboard-learner-registration',
                    params: {
                        learnerId: this.learner.id,
                        registrationId: this.registration.id
                    }
                })
            }
        }
    }
</script>

<style scoped>

    .card-pricing >>> .progress {
        background-color: #57587D;
    }

</style>
